import { InputMask } from "primereact/inputmask";
import {
  type FieldValues,
  type Path,
  type UseFormReturn,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { REGEX_SSN } from "src/core/validation/validation";
import { useProfile } from "src/features/auth/hooks/useProfile";

export interface SSNFormData extends FieldValues {
  ssn?: string;
}

type SSNProps<T extends SSNFormData> = {
  form: UseFormReturn<T, any, T>;
  required: boolean;
};

export function SSNField<T extends SSNFormData>({
  form,
  required = true,
}: SSNProps<T>) {
  const { t } = useTranslation();
  const { ssnMask } = useProfile();

  const error = form.formState.errors.ssn as Record<string, any> | undefined;

  return (
    <>
      <InputMask
        id="ssn"
        mask={ssnMask}
        placeholder={ssnMask}
        invalid={!!error}
        {...form.register("ssn" as Path<T>, {
          required: {
            value: required,
            message: t("Error.Required"),
          },
          pattern: {
            value: REGEX_SSN,
            message: t("Error.Pattern"),
          },
        })}
      />
      {error && <small className="p-error block">{error.message}</small>}
    </>
  );
}
